function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-enjeuActivite");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-enjeuActivite",
  fill: "#D93252"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.1423048,3 L17.142,11.535 L24.5346097,7.26794919 L26.5346097,10.7320508 L19.143,14.999 L26.5346097,19.2679492 L24.5346097,22.7320508 L17.142,18.464 L17.1423048,27 L13.1423048,27 L13.142,18.464 L5.75,22.7320508 L3.75,19.2679492 L11.141,14.999 L3.75,10.7320508 L5.75,7.26794919 L13.142,11.535 L13.1423048,3 L17.1423048,3 Z",
  id: "Combined-Shape"
})));

const SvgIco30EnjeuActivite = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EnjeuActivite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-enjeuActivite.1db04059.svg";
export { ForwardRef as ReactComponent };